import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { SettingsGroup } from "../SettingsGroup/SettingsGroup";
import { PrevArrowIcon, BasketIcon } from "../../assets/icon";
import { FormConfiguration } from "../FormConfiguration/FormConfiguration";
import { MobileConfig } from "../MobileConfig/MobileConfig";

import { changeColorSection } from "../../redux/actions/Settings";

import s from "./Panel.module.scss";
import { assetsMap } from "../../utils/assetsMap";
import { DEFAULT_BOAT_SKU } from "../../utils/constants";
import { useHistory, useParams } from "react-router";

export const Panel = ({ ...props }) => {
  const { mobileView, stepPanel, setStepPanel } = props;
  

  const nextStep = () => {
    setStepPanel(stepPanel + 1);
  };

  const prevStep = () => {
    setStepPanel(stepPanel - 1);
  };

  const {
    Settings: { settings },
  } = useSelector((settings) => settings);

  let { id } = useParams();
  let history = useHistory();
  const sku = id || DEFAULT_BOAT_SKU;
  const boatName = !!assetsMap[sku]
    ? assetsMap[sku].name
    : assetsMap[DEFAULT_BOAT_SKU].name;

  const panelClass =
    !!mobileView && stepPanel === 2
      ? `${s.panel} ${s.panel_fishStep}`
      : `${s.panel}`;

  const onBreakListBoat = () => {
    history.push("/");
  };

  const renderConfiguration = () => {
    return (
      <>
        <div className={`${s.panel__box} ${s.panel__box_descktop}`}>
          <div className={s.panel__box_back} onClick={() => onBreakListBoat()}>
            <PrevArrowIcon className={s.prewIcon} />
            <div className={s.name}>{boatName}</div>
          </div>
          <div className={s.panel__editor_box}>
            <div className={s.panel__editor_settings_wrap}>
              <div className={s.panel__editor_settings}>
                {settings &&
                  settings.map((setting) => {
                    return (
                      <SettingsGroup
                        key={setting.id}
                        changeColor={changeColorSection(setting.id)}
                        setting={setting}
                      />
                    );
                  })}
              </div>
            </div>
            <div className={s.panel__editor_footer}>
              <div
                className={`${s.btn} ${s.btn_blue} ${s.btn_icon_box}`}
                onClick={() => nextStep()}
              >
                <div className={s.btn_icon}>
                  <BasketIcon />
                </div>
                <div className={s.name}>Get a quote</div>
              </div>
            </div>
          </div>
        </div>
        <div className={`${s.panel__box_mobil}`}>
          <MobileConfig />
          {/* <div className={s.panel__editor_footer}>
            <div
              className={`${s.btn} ${s.btn_blue} ${s.btn_icon_box}`}
              onClick={() => nextStep()}
            >
              <div className={s.btn_icon} onClick={() => nextStep()}>
                <BasketIcon />
              </div>
              <div onClick={() => nextStep()} className={s.name}>
                Get a quote
              </div>
            </div>
          </div> */}
        </div>
      </>
    );
  };

  const renderForm = () => {
    return (
      <div className={`${s.panel__wrap_form}`}>
        <div className={`${s.panel__box}`}>
          <div className={s.panel__box_back} onClick={() => prevStep()}>
            <PrevArrowIcon />
            <div className={s.name}>Back to build</div>
          </div>
          <div className={s.panel__form_box}>
            <FormConfiguration />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className={panelClass}>
      {stepPanel === 1 && renderConfiguration()}
      {stepPanel === 2 && renderForm()}
    </div>
  );
};
